import React from 'react';
import {
  fromSliderToAzimuthValue,
  fromAzimuthToSliderValue,
} from '@/utils/azimuth';
import { Slider } from '@/components/shadcn/slider';
import ResetGameSimpleIcon from '@/components/ui/icons/trainers/ResetGameSimpleIcon';

interface IProps {
  azimuth: number;
  initialAzimuth: number;
  updateAzimuth: (azimuth: number) => void;
}

const AzimuthSlider: React.FC<IProps> = ({
  azimuth,
  initialAzimuth,
  updateAzimuth,
}) => {
  return (
    <div className="my-4 flex w-full flex-row items-center justify-center space-x-4">
      <Slider
        className="bg-electricBlue-800/50"
        max={1}
        min={0}
        value={[fromAzimuthToSliderValue(azimuth, initialAzimuth)]}
        step={0.00001}
        onValueChange={(sliderValue: number[]) => {
          const newAngle = fromSliderToAzimuthValue(
            sliderValue[0],
            initialAzimuth,
          );
          updateAzimuth(newAngle);
        }}
      />
      <div
        className="z-10 size-6 cursor-pointer fill-electricBlue-500"
        onClick={() => {
          updateAzimuth(initialAzimuth);
        }}>
        <ResetGameSimpleIcon />
      </div>
    </div>
  );
};

export default AzimuthSlider;
